import { makeStyles, Theme } from '@material-ui/core';

type Props = {
  statusColour: string;
  statusSize: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: (props: Props) => ({
    height: props.statusSize,
    width: props.statusSize,
    backgroundColor: props.statusColour,
    borderRadius: '50%',
    alignSelf: 'center',
  }),
}));

export default useStyles;
